import script from "./TerminalTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./TerminalTab.vue?vue&type=script&lang=ts&setup=true"

import "./TerminalTab.vue?vue&type=style&index=0&id=4f0399a9&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f0399a9"]])

export default __exports__